const DAY_IN_MILLISECONDS =  1000 * 60 * 60 * 24;
const YEAR_IN_MILLISECONDS = 1000 * 60 * 60 * 24 * 365;
const INVALID_IDS = [5002];

const commonCookieSettings = {
	path: '/',
	httpOnly: false,
}

exports.cookieSettings = Object.freeze({
	sessionId: { ...commonCookieSettings },
	dailyId: { ...commonCookieSettings, maxAge: DAY_IN_MILLISECONDS },
	permanentId: { ...commonCookieSettings, maxAge: YEAR_IN_MILLISECONDS },
})

exports.isUuid  = function(value) {
	return  /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(value)
}

exports.getCookie = function(target = {}, key) {
	return typeof target === 'object' && isUuid(target[key])
		? target[key]
		: undefined
}

function makeWord() {
	return Math.floor((1 + Math.random()) * 0x1000).toString(16)
}

function createUuid({ prefix } = {}) {
	const trimmedPrefix = Math.max(1000, Math.min(prefix || 0, 9999))
	return `${prefix ? trimmedPrefix : makeWord()}${makeWord()}-${makeWord()}-${makeWord()}-${makeWord()}-${makeWord()}${makeWord()}${makeWord()}`.toUpperCase()
}

exports.isInvalidID = function(id) {
	if (id == null) {
		return false;		
	}
	return INVALID_IDS.some(function (invalidId) {
		return id.indexOf(invalidId) === 0;
	});
}

exports.initialiseIDs = function({ sessionId, dailyId, permanentId }) {
	return {
		dailyId: dailyId || createUuid({ prefix: 5004 }),
		sessionId: sessionId || createUuid({ prefix: 5001 }),
		permanentId: permanentId || createUuid({ prefix: 5003 }),
	};
}

exports.base64Decode = function(data) {
	return Buffer.from(data, "base64").toString();
}

exports.base64Encode = function(string) { 
	return new Buffer(string).toString("base64");
}

exports.formattedNow = function() {
	function pad(element) {
		return element <= 9 ? "0" + element : element;
	}

	var date = new Date();
	return `${date.getUTCFullYear()}${pad(date.getUTCMonth() + 1)}${pad(date.getUTCDate())}T${pad(date.getUTCHours())}${pad(date.getUTCMinutes())}${pad(date.getUTCSeconds())}Z`
}

exports.parseQueryFromDocument = function(document) {
	let query = {}
	if (document && document.location && document.location.search) {
		query = document.location.search
			.replace('?', '')
			.split('&')
			.filter(tuple => /.+=.+/.test(tuple))
			.reduce(
				(carry, tuple) => ({ 
					...carry,
					[tuple.split('=')[0].trim()]: tuple.split('=')[1]
				}),
				{}
			);
	}
	return query
}